"use client";

import * as React from "react";
import { ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const partnerLinks = [{
  title: "Tresore - Sicherheit",
  description: "Tresore, Datensicherungsschränke, Waffenschränke und Möbeltresore verschiedener Hersteller. Auch Tresor-Service und Transport deutschlandweit und ins benachbarte Ausland.",
  buttonText: "Zu Tresor-Discount",
  url: "https://www.tresor-discount.de"
}, {
  title: "Lagereinrichtungen",
  description: "Steckregale, Archivregale, Weitspannregale, Rollregalanlagen, Kragarmregale, Lagerbühnen und Industrie-Trennwände. Auf Wunsch auch mit Montage bundesweit.",
  buttonText: "Zu MH-Regale",
  url: "http://www.mh-regale.de"
}];
export default function Links() {
  return <section id="links" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            Links
          </h2>
          <p className="text-muted-foreground text-lg">
            Hier finden Sie Empfehlungen zu unseren vertrauensvollen Partnern für Sicherheitstechnik und Lagereinrichtungen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {partnerLinks.map((link, i) => <Card key={i} data-index={i} className="flex flex-col h-full border-border shadow-sm hover:shadow-md transition-shadow duration-200">
              <CardHeader>
                <CardTitle className="text-xl">{link.title}</CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription className="text-base text-muted-foreground leading-relaxed">
                  {link.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="pt-4 border-t border-border/50 mt-auto">
                <Button asChild variant="outline" className="w-full sm:w-auto group">
                  <Link to={link.url} newTab={true}>
                    {link.buttonText}
                    <ExternalLink className="ml-2 size-4 text-muted-foreground group-hover:text-foreground transition-colors" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}